import { useEffect, useState } from "react";
import "./Navbar.scss";
const kotamLogo = "/assets/images/kotam-white-logo.png";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav className={`navbar ${scrolled ? "navbar--scrolled" : ""}`}>
      <a href="#top" className="navbar__brand" aria-label="Kotam: Conquest home">
        <img
          src={kotamLogo}
          alt="Kotam: Conquest"
          className="navbar__logo"
        />
      </a>
      {/* <a href="#top" className="navbar__brand">
        <img
          src={kotamLogo}
          alt="Kotam: Conquest"
          className="navbar__logo"
        />
        <span className="navbar__crest">K</span>
        <span>

          <strong>Kotam</strong>
          <small>Conquest</small>
        </span>
      </a> */}

      <div className="navbar__links">
        <a href="#gameplay">Gameplay</a>
        <a href="#features">Features</a>
        <a href="#gallery">Gallery</a>
        <a href="#signup" className="navbar__cta">Join Early Access</a>
      </div>
    </nav>
  );
}
